import React from 'react';
import {Box} from "@material-ui/core";

export default () => {
  return (
    <Box height="calc(100vh - 220px)">
      <div className="h layoutRow jcC aiC f16">
        If you want to purchase a new terminal please write us a mail to <a href="mailto:info@lunu.io" className="ml6">info@lunu.io</a>
      </div>
    </Box>
  )
}
